/**
 * Humanize file size
 * @param {number} size - File size in bytes
 * @returns {string} Humanized file size with unit
 */
export default function humanizeFileSize(size) {
  var i = Math.floor(Math.log(size) / Math.log(1024));
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + " " + ["B", "kB", "MB", "GB", "TB"][i];
}
